import { Component, ViewChild, ElementRef, Input, OnInit,Output,EventEmitter } from '@angular/core';
import { Chart } from 'chart.js/auto';
import * as moment from 'moment';
import * as _ from 'lodash'
import { TootipService } from '../tooltip/tootip.service';
import { TooltipComponent } from '../tooltip/tooltip.component';
@Component({
    selector: 'app-ltms-line-chart-view',
    templateUrl: './ltms-line-chart-view.component.html',
    styleUrls: ['./ltms-line-chart-view.component.scss'],
    imports: [TooltipComponent]
})
export class LtmsLineChartViewComponent implements OnInit {
  @ViewChild('chartCanvas', { static: true }) chartCanvas!: ElementRef<HTMLCanvasElement>;
  @Input() config: any = {}
  @Input() componentId: string = '';
  @Output() onSelect = new EventEmitter<any>()
  private chartInstance: Chart | any;

  canvasId:string="ltms-line-chart";
  xValues: any[] = [];
  yValues: any[] = [];
  isFullscreen: boolean = false;
  yMin: number = 0;
  yMax: number = 0;
  oriantation: number = 90
  legendDisplay: boolean = false
  gradientColors: any = ['#66B846', '#66B8460F']
  borderColor:any='#66B846'
  pointBorderColor:any='white'
  pointBackgroundColor:string='rgba(102, 184, 70, 1)'
  pointHoverBackgroundColor:string= '#66B846'
  dateFormats: any = {
    'Hourly': "hh:mm A",
    'Daily': "DD MMM 'YY",
    'Weekly': "DD MMM 'YY",
    'Monthly': "MMM 'YY",
    'Quarterly': "MMM 'YY",
    'Yearly': "YYYY",
  }
  trendType: string = 'Hourly'
  chartTitle: string = '';
  chartDescription: string = '';
 
  xAxisConfig: any = {};
  yAxisConfig: any = {}
  axisConfig: any = {
    title: {
      padding: 0,
      display: true,
      text: "< Label Name >",
      font: {
        size: 13,
        family: 'Asap',
        // weight: 'bold'
      },
      color: '#000000',
    },
    tick_font: {
      family: 'Asap',
      size: 13,
      lineHeight: 0.16,
    }
  }

  tooltipId: string = "chartjs-tooltip";
  tooltipTitle: string = '';
  tooltipData: any = [];
  tooltipFields: any = [];
  tooltipValues: any[] = [];

  constructor(public _tootipService: TootipService) { }

  ngOnInit(): void {
    this.initChart()
  }

  ngOnChanges() {
    this.initChart()
  }
  clone(data:any){
    return JSON.parse(JSON.stringify(data))
  }
  initChart() {
    // new config patterns
    this.xValues = _.get(this.config, 'chart.xValues', []);
    this.yValues = _.get(this.config, 'chart.yValues', []);
    this.tooltipData = _.get(this.config, 'chart.tooltipData', []);
    this.tooltipFields = _.get(this.config, 'chart.tooltipFields', []);

    this.canvasId = _.get(this.config, 'chartId', this.canvasId);
    this.oriantation = _.get(this.config, 'chart.oriantation', this.oriantation);
    this.legendDisplay = _.get(this.config, 'chart.legendDisplay', false);
    this.chartTitle = _.get(this.config, 'chart.title', this.chartTitle);
    this.trendType = _.get(this.config, 'chart.trendType', this.trendType);
    this.chartDescription = _.get(this.config, 'chart.description', this.chartDescription);
    this.xAxisConfig = _.merge(this.clone(this.axisConfig), _.get(this.config, 'xAxis', {}));
    this.yAxisConfig = _.merge(this.clone(this.axisConfig), _.get(this.config, 'yAxis', {}));
    this.gradientColors = _.get(this.config, 'chart.gradientColors', this.gradientColors);
    this.borderColor = _.get(this.config, 'chart.borderColor', this.borderColor);
    this.pointBorderColor = _.get(this.config, 'chart.pointBorderColor', this.pointBorderColor);
    this.pointBackgroundColor = _.get(this.config, 'chart.pointBackgroundColor', this.pointBackgroundColor);
    this.pointHoverBackgroundColor = _.get(this.config, 'chart.pointHoverBackgroundColor', this.pointHoverBackgroundColor);

    const tempValues= _.filter(this.yValues,(value:any)=>{
      return !isNaN(value)
    })
    const minY = Math.min(...tempValues);
    const maxY = Math.max(...tempValues);
    if (this.yAxisConfig.min_y === 0) {
      this.yMin = this.yAxisConfig.min_y;
    } else {
      this.yMin = minY - 1;
    }
    
    if (this.yAxisConfig.max_y) {
      this.yMax = maxY + this.yAxisConfig.max_y;
    } else {
      this.yMax = maxY + 1;
    }
    this.yMax = Math.round(this.yMax);
    this.showChart();
  }
  private showChart(): void {
    const self = this
    this.destroyChart();
    this._tootipService.tooltipPositionHandeler();
    const ctx = this.chartCanvas.nativeElement.getContext('2d');
    if (ctx) {
      var gradient = ctx.createLinearGradient(0, 0, 0, 250);
      _.each(this.gradientColors, (color: string, index: number) => {
        gradient.addColorStop(index, color);
      })
      this.chartInstance = new Chart(ctx, {
        type: 'line',
        data: {
          labels: this.xValues,
          datasets: [
            {
              data: this.yValues,
              borderColor: this.borderColor,
              borderWidth: 2,
              pointBorderWidth: 2,
              pointRadius: 6,
              pointBorderColor: this.pointBorderColor,
              fill: true,
              backgroundColor: gradient,
              // pointHoverRadius: 5,
              pointBackgroundColor: this.pointBackgroundColor,
              pointHoverBackgroundColor: this.pointHoverBackgroundColor,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              ticks: {
                autoSkip: false,
                maxRotation: this.oriantation,
                minRotation: this.oriantation,
                color: _.get(this.xAxisConfig,'tick_color','#7F7F7F') ,
                callback: function (val: any, index: any) {
                  // format string to specific date format if string is date string else return label
                  const label = this.getLabelForValue(val)
                  if (moment(label).isValid() && self.dateFormats[self.trendType]) {
                    if(self.trendType == 'Quarterly'){
                      return  moment(label).format('MMM')+"-"+moment(label).endOf('quarter').format('MMM')+" "+ moment(label).format('YYYY');
                    }
                    return moment(label).format(self.dateFormats[self.trendType]);
                  } else {
                    return label
                  }
                },
                font:_.get(this.xAxisConfig,'tick_font',{})
              },
              title: _.get(this.xAxisConfig,'title',{
                padding: 0,
                display: true,
                text: "< Label >",
                font: {
                  size: 14,
                  family: 'Asap',
                },
                color: '#000000',
              }),
            },
            y: {
              min: this.yMin,
              max: this.yMax,
              ticks:{
                precision : 0
              },
              title:_.get(this.yAxisConfig,'title',{
                display: true,
                text: "< Label >",
                color: '#7F7F7F',
                font: {
                  family: 'Asap',
                  size: 13,
                }
              }),
            },
          },
          plugins: {
            legend: {
              display: this.legendDisplay,
            },
            tooltip: {
              enabled: false,
              position: 'nearest',
              external: function (context) {
                const data = self._tootipService.tooltipHandler(context, {
                  dateFormats: self.dateFormats,
                  trendType: self.trendType,
                  tooltipId:self.tooltipId,
                  tooltipFields: self.tooltipFields,
                  tooltipData: self.tooltipData
                });
                self.tooltipValues = data.tooltipValues
                self.tooltipTitle = data.tooltipTitle
              }
            }
          },
          onClick: (event: any, element: any, chart: any) => {
            const { 0: { index: index } } = element;
            const { data: { labels: labels, datasets: datasets } } = chart;
            let label = labels[index];
            let eventData:any = {
              index: index,
              data: {
                labels: labels,
                datasets: datasets
              },
              values: {
                label: label,
                datesets: _.map(datasets, (dataset: any) => {
                  return {
                    label: dataset.label,
                    value: dataset.data[index]
                  }
                })
              }
            }
            if(moment(label).isValid()){
              const dateRange = this.getDateRange(label,this.trendType)
              eventData.dateRange = dateRange
            }
            this.onSelect.emit(eventData)
          }
        },
      });
    }
  }

  private destroyChart(): void {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = undefined;
    }
  }

  getDateRange(dateString:string,trendType:string){
    const startDate = moment(dateString).startOf('day')
    let endDate:any = ''
    switch(trendType){
      
      case 'Weekly':
        endDate = moment(startDate).endOf('week')
        break;
      case 'Monthly':
        endDate = moment(startDate).endOf('month')
        break;
      case 'Quarterly':
        endDate = moment(startDate).endOf('quarter');
        break;
      case 'Yearly':
        endDate = moment(startDate).endOf('year');
        break;
      case 'Hourly':
      case 'Daily':
      default:
          endDate = moment(startDate).endOf('day')
           break;
    }
    return {
      startDate:moment(startDate).format('YYYYMMDD'),
      endDate:moment(endDate).format('YYYYMMDD')
    }
  }
  // private updateChartData() {
  //   this.chartInstance.data.labels = this.config.chartConfig.xValues;
  //   this.chartInstance.data.datasets[0].data = this.config.chartConfig.yValues;
  //   this.chartInstance.update();
  // }
}
